"use client";
/**
 * One-shot toast summarising a plan DOWNGRADE reconcile (habits archived, pets
 * rested, packs left). Mounted app-wide; on mount it reads + CLEARS the pending
 * notice (set server-side by PlanTransitionService when the tier dropped), so the
 * user learns what changed exactly once. Reversible — an upgrade restores it.
 */
import { useEffect, useRef } from "react";
import { useTranslations } from "next-intl";
import { toast } from "@owlcat/ui";
import { takeDowngradeNotice } from "../actions/plan";

export function DowngradeNoticeToast() {
  const t = useTranslations("habits.plan");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    takeDowngradeNotice()
      .then((n) => {
        if (!n) return;
        const parts: string[] = [];
        if (n.habits > 0) parts.push(t("downgradeHabits", { count: n.habits }));
        if (n.pets > 0) parts.push(t("downgradePets", { count: n.pets }));
        if (n.packs > 0) parts.push(t("downgradePacks", { count: n.packs }));
        toast(t("downgradeTitle"), {
          description: parts.length ? `${parts.join(" · ")}. ${t("downgradeReversible")}` : t("downgradeReversible"),
          duration: 8000,
        });
      })
      .catch(() => {});
  }, [t]);

  return null;
}
